/* global axios */
import ApiClient from './ApiClient';

// v92: cliente do PROXY do Simulador CLT (Rails -> clt_clt-dash:8788).
// Os paths/payloads espelham o front do digitador v86 de producao.
class CltSimuladorAPI extends ApiClient {
  constructor() {
    super('clt_simulador', { accountScoped: true });
  }

  get(path, params = {}) {
    return axios.get(`${this.url}/${path}`, { params });
  }

  post(path, body = {}, headers = {}) {
    return axios.post(`${this.url}/${path}`, body, { headers });
  }
}

export default new CltSimuladorAPI();
